import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'osca-content',
  templateUrl: './content.component.html',
  styles: []
})
export class ContentComponent implements OnInit {
  @Input() dataSource: string[];
  constructor() { }

  ngOnInit() {
  }

}
